module.exports = __webpack_public_path__ + "img/3.168e8bcf.jpg";